export default __webpack_public_path__ + "static/media/3812.c330e17a.png";